import { render, staticRenderFns } from "./ManningHistoryIndex.vue?vue&type=template&id=32bf1f14&scoped=true&"
import script from "./ManningHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./ManningHistoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf1f14",
  null
  
)

export default component.exports